/* global $, API */

import getCSRF from '../../helpers/getCSRF';

const Uppy = require('@uppy/core');
const DragDrop = require('@uppy/drag-drop');
const XHRUpload = require('@uppy/xhr-upload');

const ALBUM_INPUT_CLASS = '.js-upload-album-input';
const SPINNER_CLASS = '.js-media-upload-spinner';
const FILE_LIST_CLASS = '.js-upload-file-list';
const DROP_CLASS = '.js-media-upload-drop';
const MODAL_CLASS = '.js-upload-modal';
const RESET_CLASS = '.js-upload-reset';

const Upload = {
  create() {
    this.template = $('#media-template').html();

    this.uppy = this.createUppyInstance();

    this.addUppyPlugins();
    this.createListeners();
  },

  /**
   * Create the Uppy plugin
   * @return {Object}
   */
  createUppyInstance() {
    return Uppy({
      id: 'uppy',
      autoProceed: true,
      debug: false,
      restrictions: {
        maxFileSize: false,
        maxNumberOfFiles: false,
        minNumberOfFiles: false,
        allowedFileTypes: false,
      },
      meta: {},
      onBeforeFileAdded: this.onBeforeFileAdded.bind(this),
      onBeforeUpload: this.onBeforeUpload.bind(this),
    });
  },

  /**
   * Add plugins like drag & drop to the Uppy plugin
   * @return {void}
   */
  addUppyPlugins() {
    this.uppy.use(DragDrop, {
      target: DROP_CLASS,
      locale: {
        strings: {
          dropHereOr: 'Plaats je bestanden hier of %{browse}',
          browse: 'blader',
        },
      },
    });

    this.uppy.use(XHRUpload, {
      endpoint: API.media.uploadUrl,
      formData: true,
      fieldName: 'files[]',
      metaFields: ['media_album_id'],
      bundle: false,
      headers: {
        'X-CSRF-TOKEN': getCSRF(),
      },
    });
  },

  /**
   * Create event listeners
   * @return {void}
   */
  createListeners() {
    this.uppy.on('upload', () => {
      this.toggleUploadField('hide');
      this.toggleAlbumInput('hide');
      this.toggleSpinner('show');
    });

    this.uppy.on('upload-success', (fileId, files) => {
      files.forEach((file) => {
        const $em = $(this.template);

        $em.find('.js-file-image').attr('src', file.thumbnail);
        $em.find('.js-file-name').text(file.name);
        $em.find('.js-file-size').text(file.size);

        $(FILE_LIST_CLASS)
          .append($em)
          .show();

        this.toggleSpinner('hide');
        this.toggleResetButton('show');
      });
    });

    this.uppy.on('complete', () => {
      this.uppy.reset();
    });

    $(MODAL_CLASS).on('hidden.bs.modal', () => {
      this.resetModal();
      window.pubsub.publish('media:filter');
    });

    $(RESET_CLASS).on('click', () => {
      this.resetModal();
    });
  },

  /**
   * Called before files are added to Uppy
   * @return {void}
   */
  onBeforeFileAdded(/* currentFile, files */) {
    // Placeholder method
  },

  /**
   * Called before files are uploaded by Uppy
   * @return {void}
   */
  onBeforeUpload(/* files, done */) {
    // Add album id to upload
    this.uppy.setMeta({
      media_album_id: $(ALBUM_INPUT_CLASS).val(),
    });
  },

  /**
   * Helper function to toggle element
   * @param {String} className
   * @param {String} state 'show' or 'hide'
   * @return {void}
   */
  toggleEl(className, state) {
    $(className).toggle(state === 'show');
  },

  toggleUploadField(state) { this.toggleEl(DROP_CLASS, state); },
  toggleAlbumInput(state) { this.toggleEl(ALBUM_INPUT_CLASS, state); },
  toggleSpinner(state) { this.toggleEl(SPINNER_CLASS, state); },
  toggleResetButton(state) { this.toggleEl(RESET_CLASS, state); },

  /**
   * Reset the modal back to it's origin state
   * @return {void}
   */
  resetModal() {
    this.toggleUploadField('show');
    this.toggleAlbumInput('show');
    this.toggleSpinner('hide');
    this.toggleResetButton('hide');

    $(FILE_LIST_CLASS).empty().hide();
  },
};

export default Upload;
